import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { TefComsBaseSelect } from './TefComsBaseSelect';

//
// renders a simple <select> with all available lifecycles fetched from the core API
//
@customElement('tef-coms-lifecycle-select')
export class TefComsLifecycleSelect extends TefComsBaseSelect {
  data: string[];

  async connectedCallback() {
    this.data = await this.api<string[]>('service/lifecycles');
    super.connectedCallback();
  }

  render() {
    const options = this.data.map((lifecycle) => html`
      <option value="${lifecycle}" ?selected=${this.selected === lifecycle}>${lifecycle}</option>
    `);

    return html`
      <select name="lifecycle" id="lifecycle-select" class="form-select">
        <option value="">Select a lifecycle</option>
        ${options}
      </select>
    `;
  }
}
